var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCimHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 54.54 47.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FR"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bouton_fr"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.55,28.59c0,4.83,0,9.54,0,14.26,0,.57,.35,.55,.74,.55,1.93,0,3.85-.03,5.78,.02,.71,.02,.93-.19,.92-.91-.03-4.37-.02-8.74-.02-13.12,0-.25-.04-.5-.06-.79h-7.36Zm3.71-23.54c-6.03,5.61-11.98,11.14-17.94,16.66-.46,.43-.65,.86-.65,1.49,.02,6.39,.01,12.78,.01,19.18v.95h11.17V24.87h14.85v18.45h11.08c.02-.27,.05-.47,.05-.67,0-6.57,.01-13.13-.02-19.7,0-.39-.26-.88-.56-1.15-4.66-4.38-9.34-8.73-14.02-13.08-1.3-1.21-2.61-2.42-3.97-3.68m22.34,42.01H4.98V25.77c-.89,.82-1.64,1.5-2.46,2.25-.85-.91-1.66-1.78-2.52-2.72C9.11,16.85,18.15,8.46,27.26,0c3.67,3.4,7.29,6.75,11.09,10.27V2.56h3.77v.93c0,3.2-.02,6.39,.02,9.59,0,.39,.22,.89,.51,1.16,3.71,3.49,7.45,6.95,11.19,10.42,.21,.19,.42,.38,.7,.63-.86,.93-1.65,1.79-2.52,2.72-.78-.71-1.54-1.4-2.42-2.19v21.24Z",
    fill: "#1d1d1b"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCimHome);
export default __webpack_public_path__ + "static/media/cim_home.977a0922cf86553264876eb608f16857.svg";
export { ForwardRef as ReactComponent };